import $ from 'jquery';
import { gsap } from 'gsap';
import { ManagePage } from '../Manage/_ManagePage.js';

export default class Op {
  constructor() {
    // console.log("▼▼▼▼▼▼▼▼▼▼▼▼OPを再生させるためにはここのコメントアウトを外す");
    // $('.op').hide();
    // console.log("▲▲▲▲▲▲▲▲▲▲▲▲OPを再生させるためにはここのコメントアウトを外す");
    const tl = gsap.timeline();
    gsap.set('.op__egg', { scale: 0, rotation: -40 });
    gsap.set('.op__objEye', { scale: 0, x: '19%', y: '-5%', rotation: -360 });
    gsap.set('.op__objHole', { scale: 0 });

    tl.to('.op__egg', {
      scale: 1,
      rotation: 0,
      duration: 2,
      ease: 'elastic.out(1,0.4)',
    })
      .to('.op__objHole', { scale: 1, duration: 0.5, ease: 'expo.out' }, '-=0.5')
      .to('.op__objEye', {
        scale: 1,
        x: '19%',
        y: '-5%',
        rotation: 0,
        duration: 1,
        ease: 'elastic.out(1,0.4)',
      })
      .to('.op__egg', {
        scale: 6,
        x: '-85%',
        y: '49%',
        opacity: 0,
        duration: 2,
        ease: 'expo.out',
        onComplete: this.gottoSlide1,
      });
  }

  gottoSlide1() {
    $('.op').hide();
    ManagePage.setPage(1);
  }
}
// (() => {})();
